import { BehaviorSubject } from 'rxjs';

const signUpModal$ = new BehaviorSubject(false);
const signUpUnsavedModal$ = new BehaviorSubject(false);
const displaySignUpModal = (isShow: boolean) => {
	signUpModal$.next(isShow);
}

const displayUnsavedChangeSignUpModal = (isShow: boolean) => {
	signUpUnsavedModal$.next(isShow);
}

export const signUpService = {
	signUpModal$: signUpModal$.asObservable(),
	signUpUnsavedModal$: signUpUnsavedModal$.asObservable(),
	displaySignUpModal,
	displayUnsavedChangeSignUpModal
};